import { Link } from 'react-router-dom';
import Styles from '../../styles/report/reportbutton.module.scss';

const Reportbutton = ({
  totalPages = 2,
  basePath = '',
  showNext = true
}) => {
  // Get current path to determine active page
  const currentPath = window.location.pathname;
  
  // Determine current page based on URL
  const getCurrentPageNumber = () => {
    if (currentPath === '/') {
      return 1;
    } else if (currentPath === '/scoreboard') {
      return 2;
    }
    // For additional pages, you can add more logic here
    return 1;
  };
  
  const currentPage = getCurrentPageNumber();

  // Custom navigation logic
  const getPagePath = (pageNumber) => {
    if (pageNumber === 1) {
      return '/';
    } else if (pageNumber === 2) {
      return '/scoreboard';
    }
    // For any additional pages, you can define the pattern here
    return `${basePath}/${pageNumber}`;
  };

  const renderPageNumbers = () => {
    const pages = [];
        
    for (let i = 1; i <= totalPages; i++) {
      pages.push(
        <Link
          key={i}
          to={getPagePath(i)}
          className={`${Styles.pageButton} ${currentPage === i ? Styles.active : ''}`}
        >
          {i}
        </Link>
      );
    }
        
    return pages;
  };

  const isOnScoreboard = currentPath === '/scoreboard';
     
  // Simple logic: if on scoreboard, show Previous, otherwise show Next
  const navButton = {
    to: isOnScoreboard ? '/' : '/scoreboard',
    text: isOnScoreboard ? '< Previous' : 'Next >',
    show: true,
    isPrevious: isOnScoreboard
  };

  return (
    <div className={Styles.pagination}>
      {/* Unified Button Group */}
      <div className={Styles.buttonGroup}>
        {/* Page Numbers */}
        {renderPageNumbers()}
                
        {/* Dynamic Navigation Button */}
        {showNext && navButton.show && (
          <Link 
            to={navButton.to}
            className={Styles.nextButton}
          >
            <span className={Styles.buttonText}>{navButton.text}</span>
                   
          </Link>
        )}
      </div>
    </div>
  );
};

export default Reportbutton;